import AskHelpPng from '../images/bboc/AskHelp.png';
import CalculatorPng from '../images/bboc/Calculator.png';
import SavingsPng from '../images/bboc/Savings.png';
import GoalPng from '../images/bboc/Goal.png';
import MissiongPng from '../images/bboc/Mission.png';
import NotesPng from '../images/bboc/Notes.png';
import CalendarPng from '../images/bboc/Calendar.png';
import GrowingMoneyPng from '../images/bboc/GrowingMoney.png';
import AssetPng from '../images/bboc/Asset.png';
import RetirementPng from '../images/bboc/Retirement.png';
import GraphPng from '../images/bboc/Graph.png';
import BooksPng from '../images/bboc/Books.png';

const bbocOverwhelmedActionItems: BbocActionItemModel[] = [
	{
		id: 1,
		title: 'Ask for help',
		image: AskHelpPng,
		description:
			"It's okay not to have all the answers. Seek help to fill knowledge gaps and make informed financial decisions."
	},
	{
		id: 2,
		title: 'Track your spending',
		image: CalculatorPng,
		description: 'Start tracking where your money goes to gain a clearer understanding of your financial habits.'
	},
	{
		id: 3,
		title: 'Get your finances on track',
		image: SavingsPng,
		description:
			'Set clear personal and financial goals for the next 12 months and beyond. Write them down to stay focused.'
	},
	{
		id: 4,
		title: 'Create an action plan',
		image: GoalPng,
		description:
			'Outline the steps you need to take—what to change, do, earn, spend, and save—to meet your financial goals.'
	},
	{
		id: 5,
		title: 'Think long-term',
		image: MissiongPng,
		description: 'Develop a basic plan to address your long-term financial needs and ensure future security.'
	}
];

const bbocGettingByActionItems: BbocActionItemModel[] = [
	{
		id: 1,
		title: 'Control your day-to-day',
		image: NotesPng,
		description: 'Track your expenses and bills to understand where your money goes and stay on top of your debt.'
	},
	{
		id: 2,
		title: 'Get your finances on track',
		image: CalendarPng,
		description:
			'Set clear personal and financial goals for the next 12 months+. Create an action plan to achieve them.'
	},
	{
		id: 3,
		title: 'Plan for retirement now',
		image: GrowingMoneyPng,
		description: "Seek help to establish a basic retirement plan and ensure you're prepared for the future."
	}
];

const bbocGettingThereActionItems: BbocActionItemModel[] = [
	{
		id: 1,
		title: 'Get a net worth report',
		image: AssetPng,
		description: 'Get a net worth report that keeps track of your assets, liabilities, debt and investments'
	},
	{
		id: 2,
		title: 'Set goals and plan ahead',
		image: GoalPng,
		description: "Set short- and long-term goals for your family's future and build a plan on how to achieve them."
	},
	{
		id: 3,
		title: 'Start planning for retirement',
		image: RetirementPng,
		description: 'Start working out your Retirement One Number – the amount you need to retire comfortably.'
	},
	{
		id: 4,
		title: 'Seek expert support',
		image: AskHelpPng,
		description: 'Identify areas where you need support and seek professional advice if necessary.'
	}
];

const bbocGoGetterActionItems: BbocActionItemModel[] = [
	{
		id: 1,
		title: 'Grow your money knowledge',
		image: BooksPng,
		description:
			'Identify areas where you need more knowledge. Set a goal and time frame to educate yourself or seek help.'
	},
	{
		id: 2,
		title: 'Reflect on your progress',
		image: GraphPng,
		description: 'Review your financial status and goals, identify gaps, and create an action plan for improvement.'
	},
	{
		id: 3,
		title: 'Review your long-term goals',
		image: GoalPng,
		description: 'Assess your long-term goals and identify any gaps in structure, strategy, or execution.'
	},
	{
		id: 4,
		title: 'Create an action plan',
		image: NotesPng,
		description: 'Develop a plan to address gaps and make progress in both the short and long term.'
	}
];

const bbocGoingSomewhereActionItems: BbocActionItemModel[] = [
	{
		id: 1,
		title: 'Quarterly financial review',
		image: GraphPng,
		description: 'Set aside time each quarter to review, refine, and execute your financial strategy to stay on track.'
	},
	{
		id: 2,
		title: 'Focus on knowledge growth',
		image: BooksPng,
		description: 'Identify areas where your financial knowledge can improve and set a goal to educate yourself.'
	},
	{
		id: 3,
		title: 'Improve your progress score',
		image: MissiongPng,
		description: 'Reflect on your Progress Score and set a goal to increase it for better financial growth.'
	},
	{
		id: 4,
		title: 'Review long-term goals',
		image: GrowingMoneyPng,
		description: 'Evaluate your long-term goals and retirement plans, identifying any gaps or changes needed.'
	}
];

const overallResultData: BbocResult[] = [
	{
		min: 85,
		max: 100,
		range: '85+',
		title: 'Going Somewhere',
		summary: [
			{
				type: 'Paragraph',
				text: 'With a highly sophisticated understanding of your finances and strong foundations built on saving and investment, you are well down the road of success. You have been able to achieve a high level of financial security and comfort due to your pragmatism and forward-thinking nature.'
			},
			{
				type: 'Paragraph',
				text: "You are highly engaged in your financial universe and enjoy the confidence and certainty that comes with being in control. It's important to you to be actively involved in optimising your investments, making high-level strategic decisions, and planning for the future. You have a clear, well-established trajectory for retirement and your long-term ability to maintain a high standard of living for yourself and your family."
			},
			{
				type: 'Quotation',
				author: 'Warren Buffett',
				text: 'Someone is sitting in the shade today because someone planted a tree a long time ago.'
			},
			{
				type: 'Paragraph',
				text: 'When it comes to financial advice, you expect responsive, proactive, and accurate expertise tailored to your goals and needs. For you, the value of professional advice comes from the level of support, detail, and complexity that a great financial adviser can provide you. To make the most out of your situation, you want flexibility, integrated and customised services and access to a variety of options.'
			}
		],
		description: [
			"You've built strong financial foundations through saving and investing, and your forward-thinking approach has led to significant financial security.",
			'"Someone is sitting in the shade today because someone planted a tree a long time ago." — Warren Buffett',
			'Staying engaged in your financial planning gives you control and confidence. With the right financial advice, you can continue to optimise your strategy and ensure a secure future for you and your family.'
		],
		actionItems: bbocGoingSomewhereActionItems
	},
	{
		min: 65,
		max: 84,
		range: '65-84',
		title: 'Go Getter',
		summary: [
			{
				type: 'Paragraph',
				text: 'When it comes to managing your financial universe, you are highly results driven and motivated by achieving the goals you set out for yourself. You feel confident building plans to help you work towards your future and are proactive about taking action to not only stay on top of your finances but get ahead of the curve.'
			},
			{
				type: 'Paragraph',
				text: "Taking control of your finances is important to you and you've built solid foundations for keeping track of your investments, cash flow and debt. You understand the importance of making the most of your savings and building and protecting your wealth with the support of professional expertise and financial advice."
			},
			{
				type: 'Quotation',
				author: 'Conrad Hilton',
				text: "Achievement seems to be connected with action. Successful people keep moving. They make mistakes, but they don't quit."
			},
			{
				type: 'Paragraph',
				text: 'Combining your appetite for learning with proactive expertise will allow you to develop and execute your wealth creation strategy and retirement plan. You can explore your options and make informed decisions with the certainty that you have considered all the risks and impacts of external factors such as changes to government legislation.'
			}
		],
		description: [
			'You’re confident in managing your finances and proactive about staying ahead. But without a clear long-term strategy, it can be difficult to ensure your future goals are met.',
			'“Achievement seems to be connected with action. Successful people keep moving. They make mistakes, but they don’t quit.” — Conrad Hilton',
			'Developing a solid wealth creation and retirement plan doesn’t have to be overwhelming. With the right guidance and proactive steps, you can secure your financial future.'
		],
		actionItems: bbocGoGetterActionItems
	},
	{
		min: 50,
		max: 64,
		range: '50-64',
		title: 'Getting There',
		summary: [
			{
				type: 'Paragraph',
				text: "You feel pretty comfortable with your financial situation and your ability to maintain your current standard of living. By focusing on the here and now, you're working towards key milestones like paying down your mortgage or achieving short-term financial aspirations. You are strongly motivated by stability and maintaining strong foundations for your personal and family finances."
			},
			{
				type: 'Paragraph',
				text: "Although you're making steady progress, you have a tendency to put off dealing with more long-term planning and decision-making. You sometimes struggle with the time, commitment and discipline required to be more in control of your finances. You may feel uncertain about whether or not you're doing everything you could be doing to secure your financial future. While you might have some idea of your goals and what you need to do to achieve them, you don't have a clear plan for the next phase of your life."
			},
			{
				type: 'Quotation',
				author: 'Stephen R. Covey',
				text: 'Goals are pure fantasy unless you have a specific plan to achieve them.'
			},
			{
				type: 'Paragraph',
				text: 'Developing a written plan for your future and exploring different options when it comes to retirement planning, investment options and managing your super will give you greater peace of mind in the long run. Setting regular check-ins as you reach the age of maximising and preserving your wealth will allow you to have peace of mind, knowing you are on the right track to comfortably retire and maintain your desired lifestyle.'
			}
		],
		description: [
			'Feeling comfortable with your finances is reassuring. Focusing on short-term goals keeps you grounded.',
			'But delaying long-term planning can cause uncertainty. Finding time and discipline to take control feels challenging.',
			'“Goals are pure fantasy unless you have a specific plan to achieve them.” — Stephen R. Covey',
			"Creating a clear plan doesn't have to be hard. Exploring retirement options and investments brings peace of mind. Secure your financial future with thoughtful planning."
		],
		actionItems: bbocGettingThereActionItems
	},
	{
		min: 25,
		max: 49,
		range: '25-49',
		title: 'Getting By',
		summary: [
			{
				type: 'Paragraph',
				text: "Staying on top of your finances can be a struggle, but you're doing what you need to do to make ends meet. Sometimes it feels impossible to get ahead because you're constantly being pulled in different directions. Between keeping up with bills, managing your mortgage repayments, and making time for work, family, and free time, you don't always feel in control of your finances."
			},
			{
				type: 'Paragraph',
				text: 'You realise you probably should be doing more to stay organised but you lack the time and capacity to really focus on getting started. This can lead to avoiding important financial decisions and sleepless nights spent worrying about your future.'
			},
			{
				type: 'Quotation',
				author: 'Zig Ziglar',
				text: "You don't have to be great to start, but you have to start to be great."
			},
			{
				type: 'Paragraph',
				text: "Taking control of your finances and planning for the future takes effort – but it doesn't have to be complicated or time-consuming. Building good financial habits, creating a plan and working towards clear goals will actually make your life easier in the long run. Most importantly, it will give you the peace of mind and long-term security you've been missing out on."
			}
		],
		description: [
			"Staying on top of your finances can be tough, especially when you're juggling bills, mortgage payments, work, and family. It’s easy to feel out of control and overwhelmed, leading to avoidance of important financial decisions.",
			'“You don’t have to be great to start, but you have to start to be great.” — Zig Ziglar',
			'Taking control doesn’t have to be complicated. Building good financial habits and setting clear goals will simplify your life and provide the peace of mind and security you need for the future.'
		],
		actionItems: bbocGettingByActionItems
	},
	{
		min: 0,
		max: 24,
		range: '0-24',
		title: 'Overwhelmed',
		summary: [
			{
				type: 'Paragraph',
				text: "Being stuck in the moment and struggling to keep on top of bills, bad debt and everyday spending can have an impact on your mental wellbeing and standard of living. When you're trapped by the pressure and anxiety of not knowing where you're at with your finances, it can be hard to see beyond your immediate needs."
			},
			{
				type: 'Paragraph',
				text: 'Making a few simple changes in the present will make a huge difference to your future. You need some support to get organised and to create a clear plan for the future for your savings and debt repayments. Freeing yourself from the day-to-day is the first step towards financial security.'
			},
			{ type: 'Quotation', author: 'Mark Twain', text: 'The secret of getting ahead is getting started.' },
			{
				type: 'Paragraph',
				text: "Now that you're aware you're struggling, it's time to take charge and build some foundations for your financial knowledge. Getting on top of the key 'need to knows' about your finances will help you build confidence in your financial decision-making and give you greater peace of mind. Start with small, actionable steps that will set you on the right track moving forward."
			}
		],
		description: [
			'Struggling with bills and debt can impact your wellbeing and make it hard to see beyond the present.',
			'"The secret of getting ahead is getting started." — Mark Twain',
			'Taking small steps to organise your finances can lead to long-term security. Build a solid foundation for your financial future with simple, actionable changes.'
		],
		actionItems: bbocOverwhelmedActionItems
	}
];

export default overallResultData;

export const bbocWelcomeDescription = [
	'The Be Better Off Challenge™ helps you assess your financial position, resilience, and confidence to guide you toward your goals.',
	"At the end, you'll receive a score with tailored recommendations. Your Partner will support you in taking action to achieve better outcomes."
];

export interface BbocResult {
	min: number;
	max: number;
	range: string;
	title: string;
	summary: { type: string; text: string; author?: string }[];
	description: string[];
	actionItems: BbocActionItemModel[];
}

export interface BbocActionItemModel {
	id: number;
	image: string;
	title: string;
	description: string;
}

export const getBbocResultContentByScore = (score: number | null | undefined) => {
	if (score == null) return null;
	return overallResultData.find(({ min, max }) => score >= min && score <= max) || null;
};
